import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { GetPipe } from './pipes/get.pipe';
import { IsActivePipe } from './pipes/is-active.pipe';
import { DropdownSelectComponent } from './components/dropdown-select/dropdown-select.component';
import { DropdownRadioComponent } from './components/dropdown-radio/dropdown-radio.component';
import { ButtonLegacyModule } from 'studio-components/button-legacy/button-legacy.module';
import { IconModule } from 'studio-components/icon/icon.module';

@NgModule({
  declarations: [DropdownSelectComponent, DropdownRadioComponent, GetPipe, IsActivePipe],
  imports: [
    CommonModule,
    FormsModule,
    MatMenuModule,
    MatButtonModule,
    ButtonLegacyModule,
    IconModule,
    MatRadioModule,
  ],
  providers: [GetPipe, IsActivePipe],
  exports: [DropdownSelectComponent, DropdownRadioComponent],
})
export class DropdownModule {}
